import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const ACCOUNT_FEATURE_GROUP: FeatureGroup = {
  guid: 'f2c5db56-8e40-4fa1-b234-9f1f2e3cff00',
  name: 'account',
  description: 'Personal account features — view and edit account details',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
